export default "__VITE_ASSET__BYtbuHGr__"